/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
import CalendarIcon from "@atlaskit/icon/glyph/calendar";
import EditorPanelIcon from "@atlaskit/icon/glyph/editor/panel";
import ComponentIcon from "@atlaskit/icon/glyph/component";
import OfficeBuildingIcon from "@atlaskit/icon/glyph/office-building";
import { ExitingPersistence, FadeIn } from "@atlaskit/motion";
import Spinner from "@atlaskit/spinner";
import dayjs from "dayjs";
import React, { ReactElement, useState } from "react";
import { useParams } from "react-router";
import { MessageContext } from "../../contexts/Message/MessageContext";
import API from "../../services/API";
import EmailIcon from "@atlaskit/icon/glyph/email";
import EmojiPeopleIcon from "@atlaskit/icon/glyph/emoji/people";
import { UserAppoinemnts } from "../Appointments/UserAppointments";
import { INote, Notes } from "./Notes";
import { AddComment } from "../../components/AddComment/AddComment";
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Props {}
interface Params {
    id: string;
}
interface DisplayInfo {
    label: string;
    icon: ReactElement;
    value: any;
    iconSize?: string;
}
interface UserDetailResponse {
    userId: string;
    birthday: string;
    firstName: string;
    insuranceName: string;
    notes: INote[];
    insuranceNumber: string;
    isInsured: boolean;
    lastModuleName: string;
    lastName: string;
    estimatedBirthDate: string;
    email: string;
    lastMood: string | number;
    appointment?: {
        callInvitationUrl: string;
        isCanceled: boolean;
        coachAppointmentUrl: string;
    };
}
export default function UserDetails({}: Props): ReactElement {
    const [loading, setLoading] = useState(true);
    const messageContext = React.useContext(MessageContext);
    const [details, setDetails] = useState<Partial<UserDetailResponse>>({});
    const params: Params = useParams();

    const loadUser = () => {
        API.HandleGetRequest<UserDetailResponse>(`/users/details/${params.id}`)
            .then((response) => {
                setDetails(response);
                setLoading(false);
            })
            .catch(() => {
                messageContext.actions.setMessage({
                    title: "Benutzer kann nicht gefunden werden",
                    titleApparencce: "danger",
                });
                setLoading(false);
            });
    };

    React.useEffect(() => {
        setLoading(true);
        loadUser();
        return () => {};
    }, [params]);
    const onSubmitComment = async (
        file: File | null,
        text: string
    ): Promise<boolean> => {
        const formData = new FormData();

        if (file) {
            formData.append("note_file", file);
        }
        if (text) {
            formData.append("note", text);
        }

        try {
            await API.handlePostRequest<any, any>(
                formData,
                `/coach-notes/add-note/${params.id}`
            );
            await loadUser();
            return true;
        } catch (error) {
            messageContext.actions.setMessage({
                title: "Etwas ist schief gelaufen!",
                titleApparencce: "danger",
            });
            alert("Etwas ist schief gelaufen!");
            return false;
        }
    };

    const iconSize = "medium";
    const getDetailsArray = (
        stateDetails: Partial<UserDetailResponse>
    ): DisplayInfo[] => [
        {
            label: "Geburtsdatum",
            icon: <CalendarIcon size={iconSize} label="Geburtsdatum" />,
            value: dayjs(stateDetails.birthday).format("DD-MM-YYYY"),
        },

        {
            label: "Versicherungsanbieter",
            icon: (
                <OfficeBuildingIcon
                    size={iconSize}
                    label="Versicherungsanbieter"
                />
            ),
            value: stateDetails.insuranceName,
        },
        {
            label: "Versicherung",
            icon: <EditorPanelIcon size={"medium"} label="Versicherung" />,
            value: stateDetails.insuranceNumber,
        },
        {
            label: "Entbindungsdatum",
            icon: <CalendarIcon size={iconSize} label="Entbindungsdatum" />,
            value: dayjs(stateDetails.estimatedBirthDate).format("DD-MM-YYYY"),
        },
        {
            label: "Letztes bearbeitetes Modul:",
            icon: (
                <ComponentIcon
                    size={iconSize}
                    label="Letztes bearbeitetes Modul:"
                />
            ),
            value: stateDetails.lastModuleName,
        },
        {
            label: "e-mail",
            icon: <EmailIcon size={iconSize} label="e-mail" />,
            value: stateDetails.email,
        },
        {
            label: "Letzte Stimmung",
            icon: <EmojiPeopleIcon size={iconSize} label="Letzte Stimmung" />,
            value: stateDetails.lastMood,
        },
    ];
    if (loading) {
        <div className="user-detail-container">
            <ExitingPersistence>
                {loading && (
                    <FadeIn>
                        {(props) => (
                            <span>
                                <Spinner size="xlarge" />
                            </span>
                        )}
                    </FadeIn>
                )}
            </ExitingPersistence>
            ;
        </div>;
    }
    return (
        <div className="user-detail-container">
            <ExitingPersistence appear>
                {!loading && (
                    <FadeIn>
                        {(props) => (
                            <div className="user-detail-wrapper">
                                <div className="user-detail-header">
                                    <div className="user-detail-name">
                                        {`${
                                            details.firstName || "keine Vorname"
                                        }  ${details.lastName || "keine Name"}`}
                                    </div>
                                    {details.appointment &&
                                        !details.appointment.isCanceled && (
                                            <div className="user-detail-name">
                                                <a
                                                    rel="noreferrer"
                                                    target="_blank"
                                                    href={
                                                        details?.appointment
                                                            ?.coachAppointmentUrl
                                                    }
                                                >
                                                    Zum Termin gehen!
                                                </a>
                                            </div>
                                        )}
                                    <div className="user-detail-items-container">
                                        {getDetailsArray(details).map(
                                            (item, index) => (
                                                <div key={index} className="user-detail-info">
                                                    <div className="user-detail-info-item">
                                                        <span>{item.icon}</span>{" "}
                                                        {item.label}:
                                                    </div>
                                                    <div className="user-detail-info-value">
                                                        {item.value}
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>

                                {details.userId && (
                                    <UserAppoinemnts userId={details.userId} />
                                )}
                                <div className="note-section">
                                    {details.notes && (
                                        <Notes notes={details.notes} />
                                    )}
                                    <AddComment
                                        onSubmitComment={onSubmitComment}
                                    />
                                </div>
                            </div>
                        )}
                    </FadeIn>
                )}
            </ExitingPersistence>
        </div>
    );
}
